<div class="card-relatorio" [ngStyle]="(documento.tipo.codigo == 'RAQ') ? { 'border-top-color': '#4C35FF' } :
      (documento.tipo.codigo == 'PCE') ? { 'border-top-color': '#3CB9E0' } : { 'border-top-color': '#FF006E'}">
  <div class="header">
    <div class="titulo-header">
      <h1>{{documento.titulo}}</h1>
    </div>
    <div>
      <ion-button fill="clear" (click)="download()">
        <ion-icon name="download-relatorio" slot="icon-only"></ion-icon>
      </ion-button>
    </div>
  </div>


  <div class="border-bottom"></div>

  <div class="body">
    <div class="periodo">
      <h1>Ano</h1>
      <span>{{documento?.ano}}</span>
    </div>
    <div class="uf">
      <h1>UF</h1>
      <span>{{documento?.sgUf}}</span>
    </div>
  </div>

  <div class="footer">
    <div class="titulo-footer">
      <h1>Tipo de documento</h1>
      <span>{{documento?.tipo.descricao}}</span>
    </div>
  </div>
</div>
